import React from 'react';
import { Checkbox } from 'ui';
import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';

interface ApplyForAllProps {
  value: boolean;
  onChange: (value: number) => void;
  translation: FavouriteAdminTranslation;
}

export const ApplyOnDescendants: React.FC<ApplyForAllProps> = ({ value, onChange, translation }) =>
  <Checkbox
    componentId={undefined}
    className={undefined}
    value={value ? 1 : 0}
    label={{ text: translation.apply_on_descendants, visible: true }}
    onChange={onChange} />;
